import { clamp } from '../geometry';
import type { Dimensions, XYPosition } from '../types';

/** Distance (screen px) from the pane edge inside which a node or connection drag pans the view (v11). */
export const AUTO_PAN_EDGE_DISTANCE = 35;

/** Pan per animation frame (screen px) at full speed (v11). */
export const AUTO_PAN_SPEED = 20;

/** How far (screen px) the pointer must go past the edge distance for full speed; the speed ramps up linearly. */
const AUTO_PAN_RAMP = 50;

/** Even one pixel inside the edge distance pans a little. */
const MIN_RAMP_STEP = 1;

const axisSpeed = (value: number, size: number): number => {
  const far = size - AUTO_PAN_EDGE_DISTANCE;
  if (value < AUTO_PAN_EDGE_DISTANCE) return clamp(AUTO_PAN_EDGE_DISTANCE - value, MIN_RAMP_STEP, AUTO_PAN_RAMP) / AUTO_PAN_RAMP;
  if (value > far) return -clamp(value - far, MIN_RAMP_STEP, AUTO_PAN_RAMP) / AUTO_PAN_RAMP;
  return 0;
};

/**
 * How far to pan the view this animation frame while a drag is held at `point` (renderer coordinates, may lie
 * outside the pane). Near the left/top edge the view moves right/down to reveal more canvas, and the other way round
 * near the right/bottom edge — measured against React Flow v11, including the pointer outside the pane.
 */
export const getAutoPanDelta = (point: XYPosition, paneSize: Dimensions): XYPosition => ({
  x: axisSpeed(point.x, paneSize.width) * AUTO_PAN_SPEED,
  y: axisSpeed(point.y, paneSize.height) * AUTO_PAN_SPEED,
});
